// extracted by mini-css-extract-plugin
export default {"pContainer":"PresentationComponent_pContainer__LktLh"};